import React, {useEffect, useState} from 'react'
import { scrollTo, numberFormat } from '../../libs/util'
import styled from "styled-components";
export default function StdpcChangeInfo({stdpcData, mediumGuide, count, mode}) {
    if(mode){}

    const [displayInfo, setDisplayInfo] = useState({ display: '' });
    const [displayType, setDisplayType] = useState('add');


    useEffect(() => {
        const NumberCount = Number(count);
        if(NumberCount === 1){
            setDisplayInfo({
                ...displayInfo,
                display: ''
            });
            setDisplayType('add');
        } else if(NumberCount > 1){
            setDisplayInfo({
                ...displayInfo,
                display: ''
            });
            setDisplayType('count');
        }
    }, [count]);

    const onMoveEstimate = () => {
        scrollTo('#layout_list_group',-100)
    }

    const onClose = () => {
        setDisplayInfo({
            ...displayInfo,
            display: 'none'
        })
    }

    let addStdpcStyle = { display: 'none' }

    //let categoryName = 0
    let stdpcName = 0
    let price = 0
    let thisMediumGuide = {}

    if (stdpcData.item_name) {
        addStdpcStyle = { display: '' }

        //categoryName = stdpcData.category.cate_name // 2021-09-01 카테고리 미노출로 미사용
        stdpcName = stdpcData.item_name
        price = numberFormat(stdpcData.price)
    }

    if (mediumGuide.length > 0) {
        addStdpcStyle = { display: '' }
        mediumGuide.map(v => {
            if (stdpcData.cate_id === v.cate_id) {
                thisMediumGuide = v
            }
            return false
        })
    }

    mediumGuide.map(v => {
        if (stdpcData.cate_id === v.cate_id) {
            thisMediumGuide = v
        }
        return false
    })


    return(
        <tr style={displayInfo}>
            <td colSpan="7">
                <div className="box-tr">
                    <div className="box-tr_top">
                        <EmptySpace/>
                        {displayType === 'add'
                            ? <strong>
                                견적 상품이 <span>추가</span>되었습니다.
                            </strong>
                            : <strong>
                                견적 상품의 <span>개수가 변경</span>되었습니다.
                            </strong>
                        }
                        <a className="btn-continue-shopping" onClick={onMoveEstimate}>
                            견적 계속 담기 <i className="icon-angle-right" />
                        </a>
                    </div>
                    <div className="box-tr_bot" style={addStdpcStyle}>
                        <ul>
                            {thisMediumGuide !== {} || (
                                <li className="box-tr_bot_mediumguide">
                                    <img
                                        src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/icon_mediumguide.jpg`}
                                        alt="미디엄가이드"
                                    />
                                    {
                                        // eslint-disable-next-line
                                    }<a>
                                        <span>
                                            {thisMediumGuide.cate_name} {thisMediumGuide.subject}
                                        </span>{' '}
                                        <em>
                                            더보기 <i className="icon-triangle-right" />
                                        </em>
                                    </a>
                                </li>
                            )}
                            {stdpcData.item_name ? (
                                <li className="box-tr_bot_stdpc">
                                    <WrapperRow>
                                        <StdpcLabel>표준PC</StdpcLabel>
                                        <div className="box-tr_bot_stdpc_conts">
                                            <strong className="t">
                                                선택된 상품이 포함된 행쇼 표준PC를 추천합니다.
                                            </strong>
                                            <a
                                                href={`${process.env.REACT_APP_SHOPPING_URL}/${stdpcData.cate_id}/${
                                                    stdpcData.item_id
                                                }/${stdpcData.idx_b_manager}`}
                                                target="_blink"
                                            >
                                                <strong>{stdpcName}</strong> <span>{price}원</span>{' '}
                                                <em>
                                                    더보기 <i className="icon-triangle-right" />
                                                </em>
                                            </a>
                                        </div>
                                    </WrapperRow>
                                </li>
                            ) : (
                                ''
                            )}
                        </ul>
                    </div>

                    <button type="button" className="btn_box-tr_clse" onClick={onClose}>
                        <img
                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/btn_compare_del.gif`}
                            alt="삭제"
                        />
                    </button>
                </div>
            </td>
        </tr>
    )
}


const EmptySpace = styled.div`
    width: 64px;
    display: inline-block;
`

const StdpcLabel = styled.div`
    &&{
        //display: block;
        text-align: center;
        line-height: 17px;
        width: 54px;
        height: 17px;
        border: 1px solid #666666;
        color: #666666;
        font-size: 12px;
        margin-right: 9px;
        background-color: #fff;
    }
`

const WrapperRow = styled.div`
    display: flex;
    flex-direction: row;
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/stdpcChangeInfo.js